// @flow
import * as React from 'react';
import {useHistory} from 'react-router-dom';
import styled from 'styled-components';
import {useLayoutState} from 'components/Layout';
import {Paragraph} from 'components/Localized';
import Image from 'components/Image';
import Space from 'components/Space';
import Settings from 'config/Settings';
import Icon from 'assets/images/home/img-kia-logo.svg';
import CheckIcon from 'assets/images/home/img-check-on.svg';

type Props = {
  nextPath?: string,
};

export default function CountrySelection(props: Props): React.Element<any> {
  const [selected, setSelected] = React.useState("");
  const [showList, setShowList] = React.useState(false);
  const history = useHistory();
  const layoutState = useLayoutState();
  React.useEffect(()=>{
    window.skipIgnoreTouchMove = true;
    return ()=>{
      window.skipIgnoreTouchMove = false;
    };
  }, []);


  const handleStart = React.useCallback(() => {
    const selectedIndex = Settings.country.indexOf(selected);
    if (selectedIndex >= 0) {
      const link = Settings.country_link[selectedIndex];
      if (link) {
        if (link === "/") {
          history.push(props.nextPath)
        }
        else {
          window.open(link, "_blank");
        }
      }
    }
    
  }, [selected, history, props.nextPath]);

  const hideLogo = React.useMemo(() => (showList && layoutState.height < layoutState.width && ((layoutState.mobile && layoutState.height < 500) || (!layoutState.mobile && layoutState.height < 500))), [showList, layoutState]);

  return (
    <Wrapper datahidelogo={hideLogo}>
      <div />
      <div>
        {!hideLogo && <React.Fragment>
          <img src={Icon} alt="logo" />
          <Space heightM={15} heightD={19} />
          <Paragraph textKey="tutorial_P00_select_country_001" />
          <Space heightM={58} heightD={118} />
        </React.Fragment>
        }
      </div>
      <CountryList selected={selected} showList={showList} onSelect={(value) => setSelected(value)} onShowList={(show) => setShowList(show)} />
      <div>
        <button disabled={selected === ""} onClick={handleStart}>
          <Paragraph textKey="tutorial_P00_select_country_003" />
        </button>
      </div>
      <div />
    </Wrapper>
  );
}

type PropsCountryList = {
  selected: string,
  showList: boolean,
  onSelect: (string) => void,
  onShowList: (boolean) => void,
};

function CountryList(props: PropsCountryList) {
  return (
    <CountryListWrapper datashow={props.showList}>
      <button onClick={() => props.onShowList(!props.showList)}>
        {(props.showList || props.selected === "") && <Paragraph textKey="tutorial_P00_select_country_002" />}
        {(!props.showList && props.selected !== "" ) && <CountryItemSelected code={props.selected} />}
        <Image source="./home/btn-drop.png" />
      </button>
      {props.showList && <div>
        {Settings.country &&
          Settings.country.map((value) => <CountryItem key={value} code={value} selected={value === props.selected} onSelect={() => {
            props.onSelect(value);
            props.onShowList(!props.showList);
          }} />)}
      </div>}
    </CountryListWrapper>
  );
}

type PropsCountryItem = {
  code: string,
  selected: boolean,
  onSelect: () => void,
};

function CountryItem(props: PropsCountryItem) {
  return (
    <ButtonCountryItem dataselected={props.selected} onClick={props.onSelect}>
      <div>
        <Image source={`./home/img-flag-${props.code}.png`} />
        <Paragraph textKey={`tutorial_P00_select_country_${props.code}`} />
        <img src={CheckIcon} alt="checked" />
      </div>
    </ButtonCountryItem>
  );
}

type PropsCountryItemSelected = {
  code: string,
  selected?: boolean,
  onSelect?: () => void,
}

function CountryItemSelected(props: PropsCountryItemSelected) {
  return (
    <ButtonCountryItemSelected dataselected={props.selected} onClick={props.onSelect}>
      <div>
        <Image source={`./home/img-flag-${props.code}.png`} />
        <Paragraph textKey={`tutorial_P00_select_country_${props.code}`} />
      </div>
    </ButtonCountryItemSelected>
  );
}

const Wrapper = styled.div`
  width: 100%;
  height: 100%;

  position: absolute;
  z-index: 2001;

  background-color: #000000;

  display: flex;
  flex-direction: column;

  > :nth-child(1) {
    height: ${(props) => (props.theme.layout.mobile ? 50 : 90)}px;
  }
  > :nth-child(2) {
    height: ${(props) => props.datahidelogo ? 0 : (props.theme.layout.mobile ? 106 - 8 : 200 - 28)}px;
    padding-bottom: ${(props) => (props.theme.layout.mobile ? 8 : 28)}px;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  > :nth-child(3) {
    flex: 1;
    overflow: hidden;
  }
  > :nth-child(4) {
    height: ${(props) => (props.theme.layout.mobile ? 80 - 25 : 96 - 28)}px;
    padding-top: ${(props) => (props.theme.layout.mobile ? 25 : 28)}px;

    display: flex;
    align-items: center;
    justify-content: center;

    > button {
      width: ${(props) => (props.theme.layout.mobile ? 285 : 350)}px;
      height: ${(props) => (props.theme.layout.mobile ? 55 : 68)}px;
      background-color: #ffffff;

      &:disabled {
        opacity: 0.5;
      }
    }
  }
  > :nth-child(5) {
    height: ${(props) => (props.theme.layout.mobile ? 50 : 70)}px;
  }
`;

const CountryListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  > :nth-child(1) {
    width: ${(props) => (props.theme.layout.mobile ? 285 : 350)}px;
    height: ${(props) => (props.theme.layout.mobile ? 55 : 68)}px;
    padding-right: ${(props) => (props.theme.layout.mobile ? 55 : 68)}px;
    border: solid 1px #ffffff;
    background-color: #000000;
    position: relative;

    display: flex;
    align-items: center;
    justify-content: center;

    > img {
      width: ${(props) => (props.theme.layout.mobile ? 55 : 68)}px;
      height: 100%;
      position: absolute;
      right: 0px;
      top: 0px;

      transform: rotate(${props => props.datashow ? 0 : 180}deg);
    }
  }
  > :nth-child(2) {
    width: ${(props) => (props.theme.layout.mobile ? 285 : 350)}px;
    flex: 1;

    border: solid 1px #364047;
    border-top: 0px;
    background-color: #041019;

    overflow-x: hidden;
    overflow-y: scroll;
    pointer-events: auto;

    &::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }  
    &::-webkit-scrollbar-thumb {
      background: #214159;
      border-radius: 5px;
    }  
    &::-webkit-scrollbar-track {
      background: #041019;
    }
  
    // For Internet Explorer
    & {
      scrollbar-face-color: #214159;
      scrollbar-track-color: #041019;
    }
  }
`;

const ButtonCountryItem = styled.button`

  width: 100%;
  height: ${(props) => (props.theme.layout.mobile ? 52 : 62)}px;

  > div {
    margin: ${(props) => (props.theme.layout.mobile ? 0 : 0)}px
      ${(props) => (props.theme.layout.mobile ? 16 : 20)}px;
    padding: ${(props) => (props.theme.layout.mobile ? 8 : 11)}px
      ${(props) => (props.theme.layout.mobile ? 4 : 10)}px;

    border-top: 1px solid #364047;
    border-bottom: 1px solid #364047;

    display: flex;
    align-items: center;

    > :nth-child(1) {
      float: left;
      width: ${(props) => (props.theme.layout.mobile ? 35 : 40)}px;
      height: ${(props) => (props.theme.layout.mobile ? 35 : 40)}px;
      padding-right: ${(props) => (props.theme.layout.mobile ? 10 : 12)}px;
    }

    > p {
      flex: 1;
      text-align: left;
    }

    > :nth-child(3) {
      float: right;
      width: ${(props) => (props.theme.layout.mobile ? 22 : 28)}px;
      height: ${(props) => (props.theme.layout.mobile ? 15 : 20)}px;
      visibility: ${(props) => props.dataselected ? 'visible' : 'hidden'};
    }
  }

  &:hover {
    background-color: #102b3f;
    > div {
      border-top: 1px solid #102b3f;
      border-bottom: 1px solid #102b3f;
    }
  }
`;


const ButtonCountryItemSelected = styled.div`

  width: 100%;
  height: ${(props) => (props.theme.layout.mobile ? 52 : 62)}px;
  margin-top: ${(props) => (props.theme.layout.mobile ? 8 : 13)}px;

  > div {
    margin: ${(props) => (props.theme.layout.mobile ? 5 : 6)}px
      ${(props) => (props.theme.layout.mobile ? 16 : 20)}px;


    display: flex;
    align-items: center;

    > :nth-child(1) {
      float: left;
      width: ${(props) => (props.theme.layout.mobile ? 35 : 40)}px;
      height: ${(props) => (props.theme.layout.mobile ? 35 : 40)}px;
      padding-right: ${(props) => (props.theme.layout.mobile ? 10 : 12)}px;
    }

    > p {
      flex: 1;
      text-align: left;
    }

    > :nth-child(3) {
      float: right;
      width: ${(props) => (props.theme.layout.mobile ? 22 : 28)}px;
      height: ${(props) => (props.theme.layout.mobile ? 15 : 20)}px;
      visibility: ${(props) => props.dataselected ? 'visible' : 'hidden'};
    }
  }


`;